/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import CohortRepository from '../../repositories/Admin/CohortRepository';
import { createRestSlice } from '../../utils/RestSlice';

const cohortsRestSlice = createRestSlice({
  resource: 'cohort',
  repository: CohortRepository,
  slices: ['loadCohorts'],
});

const initialState = {
  ...cohortsRestSlice.initialState,
};

const cohortsSlice = createSlice({
  name: 'cohorts',
  initialState,
  reducers: {
    ...cohortsRestSlice.reducers,
  },
});

export default cohortsSlice.reducer;

export const cohortsRestHooks = cohortsRestSlice.hooks(cohortsSlice, [
  'admin',
  'CohortsSlice',
]);
